module.exports = __webpack_public_path__ + "uploadSample.46a671435f78c8cd23c027d4e2af2ef2.png";